module.exports = __webpack_public_path__ + "img/safari-logo.64d27283.png";